export default function PHP_pathinfo() {
  return (
    <div>
      <h1>PHP_pathinfo</h1>
    </div>
  );
}
